/**
 * §19 M9.3 chat: project / workstream channels and 1:1 / group direct messages, with threads, @mentions, reactions,
 * attachments, read state and search. Everything is tenant-isolated and membership-scoped by Postgres RLS.
 */
/** #153 `team`: a group's own channel (Administration → Groups), its members always the group's. */
export const CHANNEL_KINDS = ['project', 'workstream', 'dm', 'group', 'team'];
/** What a chat can be "about" (started from a row / document / action / plan task). */
export const CHAT_SUBJECT_TYPES = ['grid_row', 'document', 'action', 'plan_task'];
export const REACTIONS = ['👍', '❤️', '😄', '🎉', '👀', '✅', '❓'];
export const MESSAGE_MAX = 8000;
export const CHANNEL_NAME_MAX = 60;
/** Realtime rooms: one per channel (new-message signals + typing), one per person (unread / new DMs). */
export const realtimeChatName = (tenantId, channelId) => `tenant:${tenantId}:chat:${channelId}`;
export const realtimeUserName = (tenantId, userId) => `tenant:${tenantId}:user:${userId}`;
export const CHAT_EVENTS_CHANNEL = 'fyr:chat-events';
// ── §19 M9.4 calls ───────────────────────────────────────────────────────────────────────────────────────────
/**
 * Where a call lives — and so who it rings: a channel's, DM's or group's members, or a meeting's named people. Calls
 * start in Chat; a row / document only offers "Start call…", which names who it will ring first.
 */
export const CALL_SCOPES = ['channel', 'dm', 'group', 'meeting'];
/** Ringing lasts this long (then it's "Join" only). */
export const CALL_RING_MS = 120_000;
//# sourceMappingURL=chat.js.map